class HelpMeChooseModal extends HTMLElement {
  constructor(){
    super();
    this._lastFocused = null;
    this._onKeydown = this._onKeydown.bind(this);
    this._onClick = this._onClick.bind(this);
  }

  connectedCallback(){
    // Ensure structure exists
    this._modal = this.querySelector('.hmc-modal') || this;
    if (!this._modal) return;

    // ARIA defaults
    if (!this._modal.hasAttribute('aria-hidden')) this._modal.setAttribute('aria-hidden','true');
    this.addEventListener('click', this._onClick);
  }

  disconnectedCallback(){
    this.removeEventListener('click', this._onClick);
    document.removeEventListener('keydown', this._onKeydown);
  }

  open(){
    this._lastFocused = document.activeElement;
    this._setHidden(false);
    document.body.classList.add('hmc-open');
    const heading = this._modal.querySelector('#hmc-title');
    const closeBtn = this._modal.querySelector('[data-hmc-close]');
    (heading || closeBtn || this._modal).focus({preventScroll:true});
    document.addEventListener('keydown', this._onKeydown);
  }

  close(){
    this._setHidden(true);
    document.body.classList.remove('hmc-open');
    document.removeEventListener('keydown', this._onKeydown);
    if (this._lastFocused && typeof this._lastFocused.focus === 'function'){
      this._lastFocused.focus({preventScroll:true});
    }
  }

  toggle(){ this.isOpen() ? this.close() : this.open(); }
  isOpen(){ return this._modal.getAttribute('aria-hidden') === 'false'; }
  _setHidden(h){ this._modal.setAttribute('aria-hidden', h ? 'true' : 'false'); }

  _onKeydown(e){
    if (!this.isOpen()) return;
    const focusables = this._modal.querySelectorAll('a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusables.length) return;
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    if (e.key === 'Tab'){
      if (e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
    } else if (e.key === 'Escape'){
      this.close();
    }
  }

  _onClick(e){
    // Close
    if (e.target.closest('[data-hmc-close]')){ e.preventDefault(); this.close(); return; }
    if (e.target.classList.contains('hmc-backdrop')){ e.preventDefault(); this.close(); return; }
  }
}

if (!customElements.get('help-me-choose-modal')){
  customElements.define('help-me-choose-modal', HelpMeChooseModal);
}

window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-hmc-open]').forEach((btn) => {
  
    btn.addEventListener('click', (e) => {
      e.preventDefault();

      const targetSel = btn.getAttribute('data-hmc-target');
      let modal = null;
      if (targetSel) {
        modal = document.querySelector(targetSel);
      }
      if (!modal) {
        const scope = btn.closest('.shopify-section, section, form, main, body');
        modal = scope ? scope.querySelector('help-me-choose-modal') : null;
      }
      if (!modal) {
        modal = document.querySelector('help-me-choose-modal');
      }
      if (modal && typeof modal.open === 'function') modal.open();
    });
  });
});
